/** @flow */

import * as actions from "@modules/service/constants/actions";
import * as shiftPatternsReducers from "./reducers";
import initialState from "./state";
import type { EmployeeSmsNotificationsState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: EmployeeSmsNotificationsState = initialState, action: Object): Object => {
  const act = {
    [actions.DeleteManagerSmsNotificationSmsRule]:
      shiftPatternsReducers.onDeleteManagerSmsNotificationSmsRule,
    [actions.DeleteManagerSmsNotificationSmsRuleSuccess]:
      shiftPatternsReducers.onDeleteManagerSmsNotificationSmsRuleSuccess,
    [actions.DeleteManagerSmsNotificationSmsRuleError]:
      shiftPatternsReducers.onDeleteManagerSmsNotificationSmsRuleError,

    [actions.AddManagerSmsNotificationSmsRule]:
      shiftPatternsReducers.onAddManagerSmsNotificationSmsRule,
    [actions.AddManagerSmsNotificationSmsRuleSuccess]:
      shiftPatternsReducers.onAddManagerSmsNotificationSmsRuleSuccess,
    [actions.AddManagerSmsNotificationSmsRuleError]:
      shiftPatternsReducers.onAddManagerSmsNotificationSmsRuleError,

    [actions.UpdateManagerSmsNotificationSmsRule]:
      shiftPatternsReducers.onUpdateManagerSmsNotificationSmsRule,
    [actions.UpdateManagerSmsNotificationSmsRuleSuccess]:
      shiftPatternsReducers.onUpdateManagerSmsNotificationSmsRuleSuccess,
    [actions.UpdateManagerSmsNotificationSmsRuleError]:
      shiftPatternsReducers.onUpdateManagerSmsNotificationSmsRuleError,

    [actions.UpdateManagerSmsNotificationSettings]:
      shiftPatternsReducers.onUpdateManagerSmsNotificationSettings,
    [actions.UpdateManagerSmsNotificationSettingsSuccess]:
      shiftPatternsReducers.onUpdateManagerSmsNotificationSettingsSuccess,
    [actions.UpdateManagerSmsNotificationSettingsError]:
      shiftPatternsReducers.onUpdateManagerSmsNotificationSettingsError,

    [actions.AddEmployeeSmsRule]: shiftPatternsReducers.onAddEmployeeSmsRule,
    [actions.AddEmployeeSmsRuleSuccess]: shiftPatternsReducers.onAddEmployeeSmsRuleSuccess,
    [actions.AddEmployeeSmsRuleError]: shiftPatternsReducers.onAddEmployeeSmsRuleError,

    [actions.DeleteEmployeeSmsRule]: shiftPatternsReducers.onDeleteEmployeeSmsRule,
    [actions.DeleteEmployeeSmsRuleSuccess]: shiftPatternsReducers.onDeleteEmployeeSmsRuleSuccess,
    [actions.DeleteEmployeeSmsRuleError]: shiftPatternsReducers.onDeleteEmployeeSmsRuleError,

    [actions.UpdateEmployeeSmsRule]: shiftPatternsReducers.onUpdateEmployeeSmsRule,
    [actions.UpdateEmployeeSmsRuleSuccess]: shiftPatternsReducers.onUpdateEmployeeSmsRuleSuccess,
    [actions.UpdateEmployeeSmsRuleError]: shiftPatternsReducers.onUpdateEmployeeSmsRuleError,

    [actions.UpdateEmployeeSmsSettings]: shiftPatternsReducers.onUpdateEmployeeSmsSettings,
    [actions.UpdateEmployeeSmsSettingsSuccess]:
      shiftPatternsReducers.onUpdateEmployeeSmsSettingsSuccess,
    [actions.UpdateEmployeeSmsSettingsError]:
      shiftPatternsReducers.onUpdateEmployeeSmsSettingsError,

    [actions.GetEmployeeSmsSettings]: shiftPatternsReducers.onGetEmployeeSmsSettings,
    [actions.GetEmployeeSmsSettingsSuccess]: shiftPatternsReducers.onGetEmployeeSmsSettingsSuccess,
    [actions.GetEmployeeSmsSettingsError]: shiftPatternsReducers.onGetEmployeeSmsSettingsError,

    [actions.GetEmployeeSmsRules]: shiftPatternsReducers.onGetEmployeeSmsRules,
    [actions.GetEmployeeSmsRulesSuccess]: shiftPatternsReducers.onGetEmployeeSmsRulesSuccess,
    [actions.GetEmployeeSmsRulesError]: shiftPatternsReducers.onGetEmployeeSmsRulesError,

    [actions.GetEmployeeSmsSchemaSuccess]: shiftPatternsReducers.onGetEmployeeSmsSchemaSuccess,
    [actions.SetEmployeeSmsCurrent]: shiftPatternsReducers.onSetEmployeeSmsCurrent,
    [actions.SetEmployeeSmsAssignments]: shiftPatternsReducers.onSetEmployeeSmsAssignments,

    [actions.SetShowAddEmployeeSmsModal]: shiftPatternsReducers.onSetShowAddModal,
    [actions.SetShowEditEmployeeSmsModal]: shiftPatternsReducers.onSetShowEditModal,
    [actions.SetShowDeleteEmployeeSmsModal]: shiftPatternsReducers.onSetShowDeleteModal,
    [actions.GetEmployeeSmsAssignmentsSuccess]:
      shiftPatternsReducers.onGetEmployeeSmsAssignmentsSuccess,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
